import React, { useState, useRef, useEffect } from 'react';
import SectionTitle from '../Common/SectionTitle';
import emailjs from '@emailjs/browser';
import './ContactStyles.css'; // Import custom styles

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    error: false,
    success: false,
    message: '',
    loading: false
  });

  // Initialize EmailJS when component mounts
  useEffect(() => {
    // Initialize EmailJS with your user ID
    emailjs.init("6gTI9WQI7W9JP6OeT");
    
    // Remove AOS attributes from all elements in this component
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const elementsWithAos = contactSection.querySelectorAll('[data-aos]');
      elementsWithAos.forEach(element => {
        element.removeAttribute('data-aos');
        element.removeAttribute('data-aos-delay');
        element.removeAttribute('data-aos-duration');
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted with data:', formData);
    
    // Set loading state
    setFormStatus({
      error: false,
      success: false,
      message: '',
      loading: true
    });

    // Send email using EmailJS
    emailjs.sendForm(
      'service_iympsb7',    // Your EmailJS service ID
      'template_xd6uae3',   // Your EmailJS template ID
      formRef.current,
      '6gTI9WQI7W9JP6OeT'   // Your EmailJS public key
    )
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        // Show success message
        setFormStatus({
          error: false,
          success: true,
          message: 'Your message has been sent. Thank you!',
          loading: false
        });

        // Reset the form after submission
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        
        // Show popup notification for 5 seconds
        setTimeout(() => {
          setFormStatus(prev => ({
            ...prev,
            success: false,
            message: ''
          }));
        }, 5000);
      })
      .catch((error) => {
        console.error('Email sending failed:', error);
        setFormStatus({
          error: true,
          success: false,
          message: 'An error occurred. Please try again later.',
          loading: false
        });
      });
  };

  return (
    <section id="contact" className="contact section">
      <SectionTitle 
        title="Contact" 
        description1="Check Our" 
        description2="Contact" 
      />

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4">
            <div className="info-item d-flex">
              <i className="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Address</h3>
                <p>C712 KLJ Noida One,</p>
                <p>Sector 62 Noida, Uttar Pradesh, 201309</p>
              </div>
            </div>

            <div className="info-item d-flex">
              <i className="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Call Us</h3>
                <p style={{fontFamily: 'sans-serif'}}>+91 9953003900</p>
              </div>
            </div>

            <div className="info-item d-flex">
              <i className="bi bi-envelope flex-shrink-0"></i>
              <div>
                <h3>Email Us</h3>
                <p>connect@digisofts.com</p>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            {formStatus.success && (
              <>
                <div className="notification-overlay"></div>
                <div className="notification-popup">
                  <div className="notification-content">
                    <i className="bi bi-check-circle"></i>
                    <p>{formStatus.message}</p>
                  </div>
                </div>
              </>
            )}
            <form 
              ref={formRef}
              className="php-email-form" 
              onSubmit={handleSubmit}
              style={{ position: 'relative', zIndex: 100 }}
            >
              <div className="row gy-4">
                <div className="col-md-6">
                  <input 
                    type="text" 
                    name="name" 
                    className="form-control" 
                    placeholder="Your Name" 
                    required
                    value={formData.name}
                    onChange={handleChange}
                    style={{ position: 'relative', zIndex: 101 }}
                  />
                </div>

                <div className="col-md-6">
                  <input 
                    type="email" 
                    className="form-control" 
                    name="email" 
                    placeholder="Your Email" 
                    required
                    value={formData.email}
                    onChange={handleChange}
                    style={{ position: 'relative', zIndex: 101 }}
                  />
                </div>

                <div className="col-md-12">
                  <input 
                    type="text" 
                    className="form-control"
                    name="subject" 
                    placeholder="Subject" 
                    required
                    value={formData.subject}
                    onChange={handleChange}
                    style={{ position: 'relative', zIndex: 101 }}
                  />
                </div>

                <div className="col-md-12">
                  <textarea 
                    className="form-control" 
                    name="message" 
                    rows="6" 
                    placeholder="Message" 
                    required
                    value={formData.message}
                    onChange={handleChange}
                    style={{ position: 'relative', zIndex: 101 }}
                  ></textarea>
                </div>

                <div className="col-md-12 text-center" style={{ display: 'flex', justifyContent: 'center' }}>
                  {formStatus.error && <div className="error-message">{formStatus.message}</div>}
                  {formStatus.loading && <div className="loading">Sending...</div>}
                  <button 
                    type="submit" 
                    disabled={formStatus.loading} 
                    className="animated-button"
                    style={{ cursor: 'pointer !important' }}
                  >
                    <div className="svg-wrapper-1" style={{ cursor: 'pointer' }}>
                      <div className="svg-wrapper" style={{ cursor: 'pointer' }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          style={{ cursor: 'pointer' }}
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path
                            fill="currentColor"
                            d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <span style={{ cursor: 'pointer' }}>Send Message</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 